import { render, staticRenderFns } from "./BaseDropdownExamples.vue?vue&type=template&id=b6590e5a"
import script from "./BaseDropdownExamples.vue?vue&type=script&lang=js"
export * from "./BaseDropdownExamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports